'use strict';
const SB_ONLINE_CLASS = 'search-bar--online';
const SB_OFFLINE_CLASS = 'search-bar--offline';
const SMALLER_PADDING = 'smaller-padding';
const LARGER_PADDING = 'larger-padding';

setTimeout(() => {
  const $searchBar = $('.search-bar');
  const $wrapper = $('.wrapper-inner.layout-container');
  if ($searchBar.hasClass(SB_ONLINE_CLASS)) {
    $wrapper.addClass(SMALLER_PADDING)
  } else if ($searchBar.hasClass(SB_OFFLINE_CLASS)) {
    $wrapper.addClass(LARGER_PADDING)
  }
}, 300);
